var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5280_18569)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.251 39.4139H78.2711C80.3142 39.4139 82.0973 39.8357 83.6225 40.6813C85.1456 41.527 86.3168 42.7026 87.1341 44.206C87.9513 45.7116 88.3599 47.4378 88.3599 49.3892C88.3599 51.3405 87.9513 53.0668 87.1341 54.5724C86.3168 56.0779 85.1456 57.2514 83.6225 58.097C82.0995 58.9427 80.3164 59.3644 78.2711 59.3644H72.251V39.4139ZM78.2711 57.1115C80.631 57.1115 82.5015 56.4341 83.8869 55.0771C85.2701 53.7202 85.9628 51.8256 85.9628 49.3914C85.9628 46.9571 85.2701 45.0626 83.8869 43.7056C82.5037 42.3486 80.631 41.6712 78.2711 41.6712H74.5935V57.1093H78.2711V57.1115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.007 59.2005C91.1898 58.7919 90.5583 58.2303 90.1125 57.5136C89.6667 56.799 89.4438 55.9862 89.4438 55.0749C89.4438 53.5694 90.0098 52.3959 91.1439 51.5503C92.2758 50.7046 93.7071 50.2829 95.4355 50.2829C96.2899 50.2829 97.0831 50.3769 97.8174 50.5626C98.5516 50.7483 99.1132 50.9625 99.5043 51.2029V50.3397C99.5043 49.2799 99.1328 48.4299 98.3899 47.7896C97.6469 47.1494 96.7073 46.8282 95.5754 46.8282C94.7756 46.8282 94.0436 47.0008 93.3728 47.3439C92.7041 47.6869 92.1753 48.1655 91.7841 48.7795L90.0011 47.4422C90.5583 46.5878 91.3253 45.9191 92.2998 45.4362C93.2744 44.9533 94.3583 44.7108 95.547 44.7108C97.4787 44.7108 98.9973 45.2177 100.103 46.2294C101.209 47.2434 101.762 48.6222 101.762 50.3681V59.3688H99.5043V57.3344H99.3929C98.9842 58.0227 98.3702 58.6062 97.553 59.0891C96.7357 59.572 95.8158 59.8145 94.7931 59.8145C93.7552 59.8145 92.8265 59.6091 92.007 59.2005ZM97.247 57.1115C97.9332 56.7029 98.4816 56.1544 98.8903 55.4683C99.2989 54.7821 99.5043 54.0283 99.5043 53.211C99.0585 52.9138 98.5101 52.6713 97.8611 52.4855C97.2099 52.2998 96.5237 52.2058 95.7983 52.2058C94.4981 52.2058 93.517 52.4746 92.8592 53.0143C92.1993 53.5541 91.8694 54.2511 91.8694 55.1034C91.8694 55.8835 92.1665 56.515 92.7609 56.9979C93.3553 57.4808 94.107 57.7234 95.0182 57.7234C95.8158 57.7234 96.5609 57.5201 97.247 57.1115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.261 45.3794H106.518V47.6367H106.63C106.964 46.7998 107.53 46.1508 108.33 45.6853C109.128 45.2221 110.002 44.9883 110.95 44.9883C111.359 44.9883 111.702 45.0167 111.981 45.0713V47.4968C111.665 47.4225 111.238 47.3854 110.699 47.3854C109.49 47.3854 108.511 47.7853 107.76 48.5829C107.008 49.3826 106.63 50.4228 106.63 51.7033V59.5895H104.261V45.3794ZM118.972 59.5305C118.48 59.3426 118.067 59.0869 117.731 58.7635C117.359 58.4051 117.079 57.9878 116.894 57.5158C116.708 57.0438 116.614 56.4669 116.614 55.7851V47.3024H114.134V45.1565H116.614V41.1446H118.983V45.1565H122.437V47.3024H118.983V55.2214C118.983 56.0189 119.131 56.6068 119.428 56.987C119.78 57.4043 120.292 57.6141 120.96 57.6141C121.498 57.6141 122.02 57.4568 122.52 57.1399V59.454C122.241 59.5829 121.959 59.6769 121.67 59.7337C121.382 59.7905 121.015 59.8167 120.569 59.8167C119.999 59.8146 119.466 59.7184 118.972 59.5305Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.4781 58.8051L28.3911 53.718C27.788 53.0974 27.4121 52.2234 27.4121 51.369C27.4121 50.9735 27.635 50.3551 27.8033 49.9989L32.4992 40.2159L33.4781 58.8051Z",
    fill: "#01579B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8939 41.1949L45.8069 36.1079C45.3633 35.6621 44.4368 35.1289 43.6545 35.1289C42.9815 35.1289 42.3216 35.2644 41.8933 35.52L32.5015 40.2159L50.8939 41.1949Z",
    fill: "#40C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5437 64.871H51.8724V59.5873L42.6751 56.6526L34.2622 59.5873L39.5437 64.871Z",
    fill: "#40C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5015 56.0671C32.5015 57.636 32.6981 58.0228 33.4804 58.8073L34.2627 59.5895H51.8729L43.2634 49.8066L32.5015 40.2181V56.0671Z",
    fill: "#29B6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1535 40.2159H32.499L51.8704 59.5873H57.1541V47.4554L50.8937 41.1949C50.0152 40.3121 49.2329 40.2159 48.1535 40.2159Z",
    fill: "#01579B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.6746 59.0017C32.8924 58.2151 32.6957 57.4415 32.6957 56.0671V40.4126L32.499 40.2159V56.0649C32.5012 57.4415 32.5012 57.8217 33.6746 59.0017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.96 47.2609V59.3928H51.6763L51.8729 59.5873H57.1566V47.4575L56.96 47.2609Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.8939 41.1949C49.9237 40.2247 49.1283 40.2159 47.9593 40.2159H32.5015L32.6981 40.4126H47.9614C48.5427 40.4126 50.0177 40.3143 50.8939 41.1949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.9596 47.2609L50.8936 41.1949L45.8065 36.1079C45.3629 35.6621 44.4364 35.1289 43.6541 35.1289C42.9811 35.1289 42.3212 35.2644 41.8929 35.52L32.5011 40.2159L27.8052 49.9989C27.6369 50.3551 27.4141 50.9735 27.4141 51.369C27.4141 52.2234 27.7899 53.0974 28.393 53.718L33.0824 58.3724C33.1938 58.5101 33.3249 58.6499 33.4822 58.8051L33.6789 59.0017L34.2667 59.5895L39.3538 64.6766L39.5504 64.8732H51.6824H51.8791V59.5895H57.1628V59.5764V47.4576L56.9596 47.2609Z",
    fill: "url(#paint0_radial_5280_18569)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5280_18569",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2873 50.0003) scale(14.8733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5280_18569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.9283,
    height: 30,
    fill: "white",
    transform: "translate(27 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/dart.f9f4554d70627f7ba27197c25086a432.svg";
export { ForwardRef as ReactComponent };